/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type NoteEntityTypeEnum = "contacts" | "containers" | "shipments" | "vessels" | "voyages" | "%future added value";
export type NoteTabQueryVariables = {
    entityType: NoteEntityTypeEnum;
    entitySlug: string;
};
export type NoteTabQueryResponse = {
    readonly noteList: ReadonlyArray<{
        readonly slug: string;
        readonly content: string;
        readonly addedAt: string;
        readonly isSticky: boolean;
        readonly addedBy: {
            readonly username: string;
        };
    }>;
};
export type NoteTabQuery = {
    readonly response: NoteTabQueryResponse;
    readonly variables: NoteTabQueryVariables;
};



/*
query NoteTabQuery(
  $entityType: NoteEntityTypeEnum!
  $entitySlug: String!
) {
  noteList(entityType: $entityType, entitySlug: $entitySlug) {
    slug
    content
    addedAt
    isSticky
    addedBy {
      username
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitySlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityType"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "entitySlug",
        "variableName": "entitySlug"
      },
      {
        "kind": "Variable",
        "name": "entityType",
        "variableName": "entityType"
      }
    ],
    "concreteType": "Note",
    "kind": "LinkedField",
    "name": "noteList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "content",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSticky",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "addedBy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteTabQuery",
    "selections": (v2/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NoteTabQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "77d72bcba86218f34d5ddeb0ed7c8a2f",
    "id": null,
    "metadata": {},
    "name": "NoteTabQuery",
    "operationKind": "query",
    "text": "query NoteTabQuery(\n  $entityType: NoteEntityTypeEnum!\n  $entitySlug: String!\n) {\n  noteList(entityType: $entityType, entitySlug: $entitySlug) {\n    slug\n    content\n    addedAt\n    isSticky\n    addedBy {\n      username\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '2a50350fcca06a8abd66190f0e818a81';
export default node;
